import { z } from 'zod';

/** POST /access/waitlist */
export const waitlistJoinSchema = z
  .object({
    note: z.string().trim().max(500).optional(),
  })
  .strict();
export type WaitlistJoinInput = z.infer<typeof waitlistJoinSchema>;

export const waitlistJoinStatusSchema = z.enum(['added', 'exists', 'has_access']);
export type WaitlistJoinStatus = z.infer<typeof waitlistJoinStatusSchema>;

/**
 * POST /access/enter (Mini App) and /internal/access/enter (bot): the plain «Старт» of a
 * person without an invitation (spec 9.1). closed = quota 0, the closed testing of before.
 */
export const enterResponseSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('has_access') }),
  z.object({ kind: z.literal('entered'), credits: z.number().int().min(0), firstReel: z.boolean() }),
  z.object({ kind: z.literal('full') }),
  z.object({ kind: z.literal('closed') }),
]);
export type EnterResponse = z.infer<typeof enterResponseSchema>;

/** POST /admin/invites */
export const inviteCreateSchema = z
  .object({
    credits: z.number().int().min(0).max(100_000),
    note: z.string().trim().max(200).optional(),
  })
  .strict();
export type InviteCreateInput = z.infer<typeof inviteCreateSchema>;

export const inviteDtoSchema = z.object({
  id: z.number().int(),
  code: z.string(),
  credits: z.number().int(),
  note: z.string().nullable(),
  status: z.enum(['open', 'used', 'revoked']),
  // Null when BOT_USERNAME is not configured.
  link: z.string().nullable(),
  usedBy: z
    .object({
      telegramId: z.number().int(),
      username: z.string().nullable(),
      firstName: z.string().nullable(),
    })
    .nullable(),
  usedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type InviteDto = z.infer<typeof inviteDtoSchema>;

export const waitlistEntryDtoSchema = z.object({
  id: z.number().int(),
  telegramId: z.number().int(),
  username: z.string().nullable(),
  firstName: z.string().nullable(),
  note: z.string().nullable(),
  invitedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type WaitlistEntryDto = z.infer<typeof waitlistEntryDtoSchema>;

/** POST /admin/waitlist/:id/admit */
export const waitlistAdmitSchema = z
  .object({
    credits: z.number().int().min(0).max(100_000),
  })
  .strict();
export type WaitlistAdmitInput = z.infer<typeof waitlistAdmitSchema>;

export const settingDtoSchema = z.object({
  key: z.string(),
  value: z.number().int(),
  description: z.string(),
});
export type SettingDto = z.infer<typeof settingDtoSchema>;

/** PATCH /admin/settings */
export const settingUpdateSchema = z
  .object({
    key: z.string().min(1).max(64),
    value: z.number().int().min(0).max(1_000_000),
  })
  .strict();
export type SettingUpdateInput = z.infer<typeof settingUpdateSchema>;
